// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}
:host .main-menu {
  max-width: 100%;
}
:host .main-menu > ul {
  list-style-type: none;
  margin: 0;
  padding: 22px 0;
}
:host .main-menu > ul .menu-item {
  position: relative;
}
:host .main-menu > ul .menu-item:after {
  background: #5dade0;
  bottom: 0;
  content: "";
  position: absolute;
  right: 100%;
  top: 0;
  transition: transform 0.2s ease-in-out;
  width: 4px;
}
.rtl :host .main-menu > ul .menu-item:after {
  left: 100%;
  right: auto;
}
:host .main-menu > ul .menu-item .item-link {
  color: rgba(17, 17, 17, 0.5);
  display: block;
  font-size: 1rem;
  font-weight: 400;
  padding: 11px 22px;
  position: relative;
  text-decoration: none;
  transition: background 0.2s ease-in-out, color 0.2s ease-in-out;
}
:host .main-menu > ul .menu-item .item-link .item-badge {
  background: rgba(17, 17, 17, 0.2);
  border-radius: 8px;
  color: #111111;
  float: right;
  font-size: 10px;
  line-height: 1;
  margin-top: 2px;
  padding: 2px 6px 4px;
}
.rtl :host .main-menu > ul .menu-item .item-link .item-badge {
  float: left;
}
:host .main-menu > ul .menu-item .item-link .icon {
  transition: color 0.2s ease-in-out;
  width: 22px;
}
:host .main-menu > ul .menu-item .item-link:hover {
  background: #bbbbbb;
  color: #ffffff;
}
:host .main-menu > ul .menu-item.menu-item-group:after {
  display: none;
}
:host .main-menu > ul .menu-item .group-title {
  color: rgba(0, 0, 0, 0.6);
  display: block;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 6px 22px 5px;
  text-transform: uppercase;
}
:host .main-menu > ul .menu-item .sub {
  list-style-type: none;
  overflow: hidden;
  margin: 0;
  max-height: 0;
  padding: 0;
  transition: max-height 0.1s ease-in-out;
}
:host .main-menu > ul .menu-item .sub .menu-item .item-link {
  padding: 5px 22px 6px 44px;
}
:host .main-menu > ul .menu-item .sub .menu-item:first-child > .item-link:before {
  border-top: 1px solid transparent;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  transition: border 0.2s ease-in-out;
}
:host .main-menu > ul .menu-item:hover:after {
  transform: translateX(4px);
}
.rtl :host .main-menu > ul .menu-item:hover:after {
  transform: translateX(-4px);
}
:host .main-menu > ul .menu-item.active:after {
  transform: translateX(4px);
}
.rtl :host .main-menu > ul .menu-item.active:after {
  transform: translateX(-4px);
}
:host .main-menu > ul .menu-item.active > .item-link {
  color: #111111;
}
:host .main-menu > ul .menu-item.active > .item-link .icon {
  color: #5dade0;
}
:host .main-menu > ul .menu-item.has-sub {
  position: relative;
}
:host .main-menu > ul .menu-item.has-sub > .item-link {
  position: relative;
}
:host .main-menu > ul .menu-item.has-sub > .item-link .caret {
  margin-top: 0.55rem;
  position: absolute;
  right: 13px;
  top: 6px;
  transition: transform 0.1s ease-in-out;
}
.rtl :host .main-menu > ul .menu-item.has-sub > .item-link .caret {
  left: 13px;
  right: auto;
}
:host .main-menu > ul .menu-item.has-sub.active > .item-link .caret {
  transform: rotate(90deg);
}
:host .main-menu > ul .menu-item.has-sub.active > .sub {
  max-height: 1000px;
}
:host .main-menu > ul .menu-item.has-sub.active > .sub > .menu-item.active:first-child > .item-link:before {
  border-top-color: rgba(34, 34, 34, 0.1);
}`, "",{"version":3,"sources":["webpack://./src/app/rt-components/main-menu/main-menu.component.scss"],"names":[],"mappings":"AAEA;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,iCAAA;AADF;AAGE;EACE,eAAA;AADJ;AAGI;EACE,qBAAA;EACA,SAAA;EACA,eAAA;AADN;AAGM;EACE,kBAAA;AADR;AAGQ;EACE,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,sCAAA;EACA,UAAA;AADV;AAGU;EACE,UAAA;EACA,WAAA;AADZ;AAIQ;EACE,4BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,+DACE;AAHZ;AAMU;EACE,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;AAJZ;AAMY;EACE,WAAA;AAJd;AAOU;EACE,kCAAA;EACA,WAAA;AALZ;AAOU;EACE,mBAAA;EACA,cAAA;AALZ;AASU;EACE,aAAA;AAPZ;AAUQ;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AARV;AAUQ;EACE,qBAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;EACA,uCAAA;AARV;AAWY;EACE,0BAAA;AATd;AAagB;EACE,iCAAA;EACA,WAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,mCAAA;AAXlB;AAkBU;EACE,0BAAA;AAhBZ;AAkBY;EACE,2BAAA;AAhBd;AAqBU;EACE,0BAAA;AAnBZ;AAqBY;EACE,2BAAA;AAnBd;AAsBU;EAEE,cAAA;AArBZ;AAuBY;EACE,cAAA;AArBd;AAyBQ;EACE,kBAAA;AAvBV;AAyBU;EACE,kBAAA;AAvBZ;AAyBY;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,sCAAA;AAvBd;AAyBc;EACE,UAAA;EACA,WAAA;AAvBhB;AA6Bc;EACE,wBAAA;AA3BhB;AA8BY;EACE,kBAAA;AA5Bd;AAkCsB;EACE,uCAAA;AAhCxB","sourcesContent":["@import '../../../assets/sass/variable';\r\n\r\n:host {\r\n  display: block;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  -webkit-overflow-scrolling: touch;\r\n\r\n  .main-menu {\r\n    max-width: 100%;\r\n\r\n    > ul {\r\n      list-style-type: none;\r\n      margin: 0;\r\n      padding: 22px 0;\r\n\r\n      .menu-item {\r\n        position: relative;\r\n\r\n        &:after {\r\n          background: main-color(A100);\r\n          bottom: 0;\r\n          content: '';\r\n          position: absolute;\r\n          right: 100%;\r\n          top: 0;\r\n          transition: transform .2s $animation;\r\n          width: 4px;\r\n\r\n          .rtl & {\r\n            left: 100%;\r\n            right: auto;\r\n          }\r\n        }\r\n        .item-link {\r\n          color: rgba(#111111,.5);\r\n          display: block;\r\n          font-size: 1rem;\r\n          font-weight: 400;\r\n          padding: 11px 22px;\r\n          position: relative;\r\n          text-decoration: none;\r\n          transition:\r\n            background .2s $animation,\r\n            color .2s $animation;\r\n\r\n          .item-badge {\r\n            background: rgba(#111111,.2);\r\n            border-radius: 8px;\r\n            color: #111111;\r\n            float: right;\r\n            font-size: 10px;\r\n            line-height: 1;\r\n            margin-top: 2px;\r\n            padding: 2px 6px 4px;\r\n\r\n            .rtl & {\r\n              float: left;\r\n            }\r\n          }\r\n          .icon {\r\n            transition: color .2s $animation;\r\n            width: 22px;\r\n          }\r\n          &:hover {\r\n            background: #bbbbbb;\r\n            color: #ffffff;\r\n          }\r\n        }\r\n        &.menu-item-group {\r\n          &:after {\r\n            display: none;\r\n          }\r\n        }\r\n        .group-title {\r\n          color: rgba(#000,.6);\r\n          display: block;\r\n          font-size: .8rem;\r\n          font-weight: 600;\r\n          padding: 6px 22px 5px;\r\n          text-transform: uppercase;\r\n        }\r\n        .sub {\r\n          list-style-type: none;\r\n          overflow: hidden;\r\n          margin: 0;\r\n          max-height: 0;\r\n          padding: 0;\r\n          transition: max-height .1s $animation;\r\n\r\n          .menu-item {\r\n            .item-link {\r\n              padding: 5px 22px 6px 44px;\r\n            }\r\n            &:first-child {\r\n              > .item-link {\r\n                &:before {\r\n                  border-top: 1px solid transparent;\r\n                  content: '';\r\n                  left: 0;\r\n                  position: absolute;\r\n                  right: 0;\r\n                  top: 0;\r\n                  transition: border .2s $animation;\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n        &:hover {\r\n          &:after {\r\n            transform: translateX(4px);\r\n\r\n            .rtl & {\r\n              transform: translateX(-4px);\r\n            }\r\n          }\r\n        }\r\n        &.active {\r\n          &:after {\r\n            transform: translateX(4px);\r\n\r\n            .rtl & {\r\n              transform: translateX(-4px);\r\n            }\r\n          }\r\n          > .item-link {\r\n            background: main-color(0);\r\n            color: #111111;\r\n\r\n            .icon {\r\n              color: main-color(A100);\r\n            }\r\n          }\r\n        }\r\n        &.has-sub {\r\n          position: relative;\r\n\r\n          > .item-link {\r\n            position: relative;\r\n\r\n            .caret {\r\n              margin-top: .55rem;\r\n              position: absolute;\r\n              right: 13px;\r\n              top: 6px;\r\n              transition: transform .1s $animation;\r\n\r\n              .rtl & {\r\n                left: 13px;\r\n                right: auto;\r\n              }\r\n            }\r\n          }\r\n          &.active {\r\n            > .item-link {\r\n              .caret {\r\n                transform: rotate(90deg);\r\n              }\r\n            }\r\n            > .sub {\r\n              max-height: 1000px;\r\n\r\n              > .menu-item {\r\n                &.active {\r\n                  &:first-child {\r\n                    > .item-link {\r\n                      &:before {\r\n                        border-top-color: rgba(#222222,.1);\r\n                      }\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
